import gql from 'graphql-tag'

export default gql`
{
  products(sort: _ID_DESC) {
    _id
    group
    name
    size
    color
    sku
    shirtId
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/products.js